import React, { useEffect, useState, useContext } from 'react';
import SEO from '~/components/seo';
import { t } from '@lingui/macro';
import { LangContext } from '~/providers/LangProvider';
import Layout from '../../src/components/layout/_layout';
import { PoliciesWrapper } from '~/styles/common';
import LoadingSplash from '~/components/loadingSplash/LoadingSplash';
import Countries from '~/components/countries_enum.ts';
import MarkdownReader from "../../src/components/markdown";
import {useRouter} from "next/router";
import FetchPolicy from "../../src/fetchPolicy";

function Gdpr({ markdownData, language, widget }) {
    const router = useRouter();
    const ctxLang = useContext(LangContext);
    const [terms, setTerms] = useState(markdownData);
    const [fetchingData, setFetchingData] = useState(false);
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        if (isMounted) {
            setFetchingData(true);
            getData(language || ctxLang.state.lang);
        }
        setIsMounted(true);
    }, [ctxLang.state.lang]);

    async function getData(lang) {
        let fetchLang = lang;
        if (!language && (lang === "es" || lang === "it" )) {
            fetchLang = "en";
        }
        const data = await FetchPolicy(fetchLang, Countries.CZECHIA_SHORT, 'pay/GDPR', 'GDPR', router?.query?.branch);
        if (null !== data.redirectUrl) {
            console.error('FetchPolicy problem, redirected to Github, terms');
            window.location.href = data.redirectUrl;
        } else {
            setTerms(data);
            setFetchingData(false);
        }
    }

    return (
        <>
            <LoadingSplash isLoading={fetchingData} overlay={false} text={null}>
                <Layout widget={widget}>
                    <SEO title={t`privacyPolicy`} />
                    <PoliciesWrapper>
                        <MarkdownReader>
                            {terms.markdownData}
                        </MarkdownReader>
                    </PoliciesWrapper>
                </Layout>
            </LoadingSplash>
        </>
    );
}

export default Gdpr;
